var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.7,
    height: 19.872,
    viewBox: "0 0 21.7 19.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_920",
    "data-name": "Tracciato 920",
    d: "M47.645,239.735a1.151,1.151,0,0,1,.711,0,1.261,1.261,0,0,1,.409.266c.222.189.491.457.9.863l4.488,4.488V252.2c0,.854,0,1.444-.038,1.9a2.3,2.3,0,0,1-.2.875,2.149,2.149,0,0,1-.94.94,2.313,2.313,0,0,1-.875.2c-.458.037-1.047.038-1.9.038H45.8c-.854,0-1.444,0-1.9-.038a2.313,2.313,0,0,1-.875-.2,2.149,2.149,0,0,1-.94-.94,2.3,2.3,0,0,1-.2-.875c-.037-.457-.038-1.047-.038-1.9v-6.848l4.488-4.488c.406-.406.675-.674.9-.863A1.261,1.261,0,0,1,47.645,239.735ZM40.4,244.4l-3,3a.85.85,0,1,0,1.2,1.2l1.549-1.549v5.184h0c0,.809,0,1.469.044,2a3.948,3.948,0,0,0,.376,1.508,3.85,3.85,0,0,0,1.682,1.682,3.935,3.935,0,0,0,1.508.376c.535.044,1.194.044,2,.044h4.472c.81,0,1.469,0,2-.044a3.935,3.935,0,0,0,1.508-.376,3.851,3.851,0,0,0,1.683-1.682,3.947,3.947,0,0,0,.376-1.508c.044-.535.044-1.2.044-2v-5.184L57.4,248.6a.85.85,0,0,0,1.2-1.2l-3-3h0l-4.737-4.737-.024-.024h0c-.376-.376-.693-.694-.975-.933a2.907,2.907,0,0,0-.984-.587,2.85,2.85,0,0,0-1.761,0,2.907,2.907,0,0,0-.984.587c-.282.239-.6.557-.975.933h0l-.024.024L40.4,244.4Z",
    transform: "translate(-37.15 -237.979)",
    fill: "#14bf96",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0bd56c7807238402a15de1fd629e858c.svg";
export { ForwardRef as ReactComponent };